import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import * as React from 'react';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../../popup/confirmrequest/confirmrequestconfirmbuttoncss';
import { ForgotPasswordOTPComponentProps, ForgotPasswordOTPComponentState } from './forgotpasswordotpcomponent';
import { UIDataModel} from '../../../toolkit/uicomponent';
import { ForgotPasswordOTPCSSStyle } from './forgotpasswordotpcss';
import { Strings } from '../../../../utils/resources/strings';
import { SendOTPDto, SendOTPDtoImpl } from '../../../../core/dto/otp/sendotp/sendotpdto';
import { MsisdnFloatingTextComponent } from '../../../toolkit/floatingtext/msisdnfloatingtext/msisdnfloatingtextcomponent';
import { MSISDNValidation } from '../../../toolkit/msisdnvalidation/msisdnvalidation';
import { AlertComponent } from '../../../toolkit/alert/alertcomponent';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { PopUpWrapperComponent } from '../../popup/popupwrappercomponent';
import { LoaderComponent } from '../../../toolkit/loader/loadercomponent';
import { LoaderWrapperComponent } from '../../popup/loaderwrappercomponent';
import { ButtonComponent } from '../../../toolkit/button/buttoncomponent';
import { ForgotPasswordOTPComponentHandler } from './forgotpasswordotpcomponent';
import { ForgotPasswordOTPMessageComponent } from './forgotpasswordotpmessage/forgotpasswordotpmessagecomponent';

import './forgot-password-style.css';

export class ForgotPasswordOTPViewImpl extends UIComponentViewImpl<UIDataModel>
{
     numberComponent: any;
     private popUpComponent: PopUpWrapperComponent;
     private loaderWrapperComponent:LoaderWrapperComponent;

     bindHandlers()
     {
        this.onRequestOtpClick = this.onRequestOtpClick.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.dismissLoader = this.dismissLoader.bind(this);
        this.onLogoClicked = this.onLogoClicked.bind(this);
     }


    draw(props: ForgotPasswordOTPComponentProps, state: ForgotPasswordOTPComponentState, cssStyle: ForgotPasswordOTPCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <>
            {
                state.isOtpSuccess && <ForgotPasswordOTPMessageComponent sectoken={state.sectoken} msisdn={state.msisdn} routeNextFeature={props.routeNextFeature} context={this.getUIProps().context}/>}
            { !state.isOtpSuccess &&
            <div id="forgot-password-wrapper" style={cssStyle.getWrapperCSSStyle()}>
                <div id="forgot-password-inner-wrapper" style={cssStyle.getInnerWrapperCSSStyle()}>
                    {/* <img onClick={this.onLogoClicked} style={{cursor: "pointer",width:'100%',height:"80px",marginBottom:'45px',marginTop:'0px',marginLeft:'-135px'}} src={props.context.getResources().getImage("mpt_logo.svg")}  /> */}
                    <img id="forgot-password-page-logo" onClick={this.onLogoClicked} style={{cursor: "pointer", marginBottom:'45px',marginTop:'0px'}} src={props.context.getResources().getImage("mpt_logo.svg")}  />
                    <label id="forgot-password-page-heading" style={cssStyle.getTitleCSSStyle()}>{props.context.getResources().getString(Strings.forgot_password)}</label>
                    <div style={cssStyle.getMobileNumberCSSStyle()}>
                        <MsisdnFloatingTextComponent maxLength={this.getUIProps().context.getResources().getString(Strings.numberMaxLength)} ref={(item: any) => this.numberComponent = item} id={"#mobileNumber"} value={props.context.getUserContext().getMsisdn()} inputType={"number"} isRequired={true} placeholder={props.context.getResources().getString(Strings.mobilenumber)} context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.numberIncorrect)}/>
                    </div>
                    
                    <div style={cssStyle.getRequestOTPButtonCSSStyle()}>
                        <ButtonComponent onClick={this.onRequestOtpClick}  style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.requestotp)}/>
                    </div>
                </div>
                <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
                <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context}/>
            </div>
            }
            </>
        );
    }

    validate(): boolean
    {
        // if(this.numberComponent.validate())
        // {
        //     let numberMinLength = +this.getUIProps().context.getResources().getString(Strings.numberMinLength);
        //     let numbermaxLength = +this.getUIProps().context.getResources().getString(Strings.numberMaxLength);

        //     if(this.numberComponent.getData().length < numberMinLength 
        //                     || this.numberComponent.getData().length > numbermaxLength)
        //     {
        //         this.numberComponent.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
        //         return false;
        //     }
            
        //     return true;
        // }
        // return false;

        if(this.numberComponent.validate())
        {
            let msisdn = MSISDNValidation.validateCCMsisdn(
                this.getUIProps().context.getResources().getString(Strings.countrycode), this.numberComponent.getData());
            
            let numberMinLength = this.getUIProps().context.getResources().getString(Strings.numberMinLength);
            let numbermaxLength = this.getUIProps().context.getResources().getString(Strings.numberMaxLength);

           
            if(!MSISDNValidation.validateLengthMsisdn(msisdn, numberMinLength, numbermaxLength))
            {
                this.numberComponent.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
                return false;
            }
            // else if(this.getContext().getUserContext().getMsisdn() === this.numberComponent.getData())
            // {
            //     this.numberComponent.setErrorMessage("Number cannot be same as logged in number.");
            // }
            
            
            return true;   
        } 
        return false;    
    }   
    
    getData(): SendOTPDto
    {
        let request = new SendOTPDtoImpl();
        request.setMsisdn(this.numberComponent.getData());

        return request;
    }
    protected onLogoClicked()
    {
        (this.getUIComponentHandler() as ForgotPasswordOTPComponentHandler).onLogoClicked();
    }
    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }

    closePopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }

    showPopup(id:string,msg:string,type:AlertType):void
    {
      
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);

    }
    onRequestOtpClick():void
    {
        (this.getUIComponentHandler() as ForgotPasswordOTPComponentHandler).onRequestOtpClick();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/forgotpasswordotp/forgotpasswordotpview.tsx